import { render } from "./adminReplyList.vue?vue&type=template&id=041cab97&scoped=true"
import script from "./adminReplyList.vue?vue&type=script&lang=js"
export * from "./adminReplyList.vue?vue&type=script&lang=js"

import "./adminReplyList.vue?vue&type=style&index=0&id=041cab97&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-041cab97"

export default script